module.exports = __webpack_public_path__ + "static/cad-designs27-fd37c8ab683952a141f8f6681b8e87c9.png";